import { useState, useEffect } from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { Portfolio } from './components/Portfolio';
import { Contact, Footer } from './components/Contact';
import { ProjectPage } from './components/ProjectPage';

export default function App() {
  const [currentProject, setCurrentProject] = useState(null);

  useEffect(() => {
    if (currentProject) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentProject]);

  const handleBack = () => {
    setCurrentProject(null);
    setTimeout(() => {
      document.getElementById('projets')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleNavClick = (href) => {
    setCurrentProject(null);
    setTimeout(() => {
      const id = href.replace('#', '');
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  if (currentProject) {
    return (
      <>
        <Navigation onLogoClick={() => setCurrentProject(null)} onNavClick={handleNavClick} />
        <ProjectPage slug={currentProject} onBack={handleBack} />
        <Footer />
      </>
    );
  }

  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <Services />
      <Process />
      <Portfolio onProjectClick={setCurrentProject} />
      <Contact />
      <Footer />
    </div>
  );
}
